import React, { useEffect, useState } from 'react';
import SlideoutLayout from '../../layout/slideout/SlideoutLayout';
import UploadActivatedForm from './UploadActivatedForm';
import { getKeyProviders } from '../../../actions/keyProviderActions';
import { uploadActivations } from '../../../actions/keyCodeActions';
import { useForm } from 'react-hook-form';
import Loading from '../../common/Loading';
import { toast } from 'react-toastify';
import { useTranslation } from 'react-i18next';
import { useAppDispatch, useAppSelector } from '../../../hooks';

export interface UploadActivatedProps {
  done: () => void;
  cancel: () => void;
}

function UploadActivated({ done, cancel }: UploadActivatedProps) {
  const { t } = useTranslation();
  const keyProviders = useAppSelector((state) => state.keyProviders);
  const dispatch = useAppDispatch();

  const {
    register,
    formState: { errors },
    handleSubmit,
    control,
  } = useForm();
  const [activatedFiles, setActivatedFiles] = useState<any[]>([]);

  const addFiles = (files: any[]) => {
    setActivatedFiles((prevFiles) => [...prevFiles, ...files]);
  };
  const removeFile = (file: any) => {
    setActivatedFiles((prevFiles) =>
      prevFiles.filter((prevFile) => prevFile !== file)
    );
  };
  const onSubmit = (data: any) => {
    Promise.all(
      activatedFiles.map((file) => uploadActivations({ file, ...data }))
    )
      .then(() => {
        toast.success(t('Activations successfully uploaded'));
        done();
      })
      .catch((e) => {
        toast.error(e.message || t('Failed to upload activations'));
      });
  };

  useEffect(() => {
    if (!keyProviders) {
      dispatch(getKeyProviders());
    }
  }, [keyProviders, dispatch]);

  return keyProviders ? (
    <SlideoutLayout
      title={t('Upload activated keys')}
      cancel={cancel}
    >
      <UploadActivatedForm
        keyProviders={keyProviders}
        register={register}
        errors={errors}
        cancel={cancel}
        submit={handleSubmit(onSubmit)}
        addFiles={addFiles}
        removeFile={removeFile}
        files={activatedFiles}
      />
    </SlideoutLayout>
  ) : (
    <Loading />
  );
}

export default UploadActivated;
